FreshStep.media = {};
FreshStep.media.upload = {
    portraitRequest: {
        type: 'Profile',
    },
    scaling: {
        profile: {
            width: 160,
            height: 160,
        },
        shelterProfile: {
            width: 206,
            height: 206,
        },
        shelterGallery: {
            width: 612,
            height: 400,
        },
    },
    // TODO: Return value for context.
    previewFile: function (input) {
        if (input.files && input.files[0]) {
            $('#modal-message').html('');
            const reader = new FileReader();
            reader.onload = function (e) {
                loadImage(
                    e.target.result,
                    function (img) {
                        if (img.type === 'error') {
                            $('#modal-message').html('Error loading image');
                            return false;
                        }
                        $('#photoChooser img').replaceWith(img);
                    },
                    {
                        maxWidth: 300,
                    }
                );
            };
            //reader.readAsDataURL(input.files[0]);
            $('.modal .hide').show();
        }
    },
    // TODO:
    setUpImageEdit: function () {
        // Set up path to the temporary image
        // FIXME: hardcoding this path is wrong
        const imageSrc = '/wp-content/uploads/media/tmp/' + FreshStep.media.upload.portraitRequest['media-id'] + '.png';

        // set scaling for the type.
        let scaling,
            ratio = 1;
        switch (FreshStep.media.upload.portraitRequest.type) {
            case 'Profile':
                scaling = FreshStep.media.upload.scaling.profile;
                break;
            case 'Shelter Profile':
                scaling = FreshStep.media.upload.scaling.shelterProfile;
                break;
            case 'Shelter Gallery':
                scaling = FreshStep.media.upload.scaling.shelterGallery;
                ratio = 2;
                break;
        }
        // Set up size of preview
        $('.photo-crop').css({
            width: scaling.width / ratio,
            height: scaling.height / ratio,
        });

        // Load temp image.
        $('#photoPreview')
            .one('load', function () {
                // Must call guillotine after photo is loaded.
                $('#photoPreview').guillotine({
                    width: scaling.width,
                    height: scaling.height,
                    onChange: function (data, action) {
                        FreshStep.media.upload.portraitRequest['photo-left'] = -Math.floor(data.x) / ratio;
                        FreshStep.media.upload.portraitRequest['photo-top'] = -Math.floor(data.y) / ratio;
                        console.log(FreshStep.media.upload.portraitRequest);
                    },
                });
            })
            .attr('src', imageSrc);
    },
    /**
     * Formerly "getFacebookPhoto"
     * TODO: make one for instagram as well? Maybe this should be moved to the facebook namespace?
     * @param callback
     */
    facebookAuthorize: function (callback) {
        // TODO: what it says.
        // Check login and call callback if successful.
        FB.getLoginStatus(function (response) {
            console.log('myAccount FB Login status = ' + response.status);

            if (response.status === 'connected') {
                callback(response);
            } else {
                if (Electro.DEBUG) {
                    console.log('FB Login request');
                }
                FB.login(function (response) {
                    if (!response.authResponse) {
                        // You didn't log in, so nothing happens
                        return;
                    }
                    if (typeof callback == 'function') {
                        callback(response);
                    }
                }, FreshStep.facebook.loginConfig);
            }
        });
    },
};
